module.exports = __webpack_public_path__ + "img/photo-studio-pizza-crumbs.ce20e308.png";